<template>
  <slide-y-down-transition :duration="500">
    <nav
      v-if="show && hasBottomNavigation"
      class="bottom-navigation desktop-none"
    >
      <ul class="bottom-navigation__items">
        <li
          v-for="(item, index) in items"
          :key="index"
          class="bottom-navigation__item"
          :class="{ active: item.active }"
          @click="setActive(item)"
        >
          <mdicon
            :name="item.iconName"
            size="20"
            class="bottom-navigation__icon"
          />

          <span class="bottom-navigation__label">{{ item.label }}</span>
        </li>
        <li
          class="bottom-navigation__item"
          @click="showParvandehNotification()"
        >
          <mdicon
            name="folder-account-outline"
            size="20"
            class="bottom-navigation__icon"
          />

          <span class="bottom-navigation__label">{{ "پرونده" }}</span>
        </li>

        <li class="bottom-navigation__item" @click="showProfilePopup">
          <ImageBox
            :downloadCode="userData.downloadCode"
            :defaultImage="defaultImage"
            :hasPreview="false"
            imageClass="bottom-navigation__image"
            wrapperClass="flex-center"
            loadingClass="left-4 width-48 height-48 rounded-circle"
          />
          <ProfileBoxPopup
            :show="profilePopup"
            :userData="userData"
            @setShow="closeProfilePopup"
          />
          <span class="bottom-navigation__label">{{ "پروفایل" }}</span>
        </li>
      </ul>
    </nav>
  </slide-y-down-transition>
</template>

<script>
import ProfileBoxPopup from "@/components/re-design/profile-box/ProfileBoxPopup.vue";
import { computed, onMounted, ref } from "vue";
import { mapGetters } from "vuex";
import { pathOr } from "ramda";
import {
  checkScreenDevice,
  generateConfig,
  generateCurrentRoute,
  goToRoute,
  renderAvatar,
  storeDispatcher,
} from "@/shared/utils";
import ImageBox from "../image-box/ImageBox.vue";

export default {
  components: { ProfileBoxPopup, ImageBox },
  computed: {
    ...mapGetters(["userInfo"]),
    ...mapGetters(["savedAudioRecordLength"]),
    userData() {
      const code = pathOr("", ["code"], this.userInfo);
      const name = pathOr("", ["person", "name"], this.userInfo);
      const family = pathOr("", ["person", "family"], this.userInfo);
      const mobile = pathOr("", ["mobile"], this.userInfo);
      const downloadCode = pathOr(
        null,
        ["person", "download_code"],
        this.userInfo
      );
      return {
        code,
        avatar: renderAvatar(this.userInfo),
        fullName: `${name} ${family}`,
        mobile,
        downloadCode,
      };
    },
    hasBottomNavigation() {
      return pathOr(true, ["hasBottomNavigation"], this.$route.meta);
    },
  },
  setup() {
    // generate nav items
    const items = ref([
      {
        routeName: "dashboard",
        iconName: "home-variant-outline",
        label: "خانه",
        active: false,
      },
      {
        routeName: "user_add_ticket",
        iconName: "headset",
        label: "پشتیبانی",
        active: false,
      },
      {
        routeName: "taskUserPage",
        iconName: "account-check-outline",
        label: "فعالیت ها",
        active: false,
      },
    ]);
    const setActive = (selectedItem) => {
      const active = pathOr(null, ["active"], selectedItem);
      const routeName = pathOr(null, ["routeName"], selectedItem);
      if (!selectedItem || !routeName || active) return;

      for (const item of items.value) {
        item.active = item.routeName === routeName;
      }
      goToRoute(routeName, {}, {}, false);
    };

    const goToVoices = () => {
      goToRoute("recorded-voice", {}, {}, false);
    };

    const show = ref(false);
    onMounted(() => {
      const currentRoute = generateCurrentRoute();
      const currentItemMenu = items.value.find(
        (item) => item.routeName === currentRoute
      );
      setActive(currentItemMenu);

      show.value = true;
    });

    // generate profile popup
    const defaultImage = computed(() =>
      generateConfig(["images", "shared", "redesign", "empty", "noUser"])
    );
    const profilePopup = ref(false);
    const showProfilePopup = () => (profilePopup.value = true);
    const closeProfilePopup = () => (profilePopup.value = false);

    // show parvandeh notification popup from store
    const showParvandehNotification = async () =>
      await storeDispatcher("showParvandehNotification", true);

    // return data to be used in template
    return {
      show,
      items,
      setActive,
      defaultImage,
      profilePopup,
      goToVoices,
      showProfilePopup,
      closeProfilePopup,
      showParvandehNotification,
    };
  },
};
</script>
